<template>
  <p :class="['Heading', { h2: variant.size === 'h2' }]">
    <slot></slot>
  </p>
</template>

<script>
export default {
  data () {
    return {};
  },
  props: {
    variant: {
      type: Object,
      default: () => ({}),
    },
  },
  created () {},
  components: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.Heading {
  margin-top: 0;
  font-size: 24px;
  margin-bottom: 10px;
}
.h2 {
  font-size: 18px;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>
